<script lang="ts">
	import ApplePayButton from './ApplePayButton.svelte'
	import { cartItems } from '$lib/stores.svelte'

	interface Props {
		showCheckout?: boolean
		onclose?: () => void
	}

	let { showCheckout = true, onclose = () => {} }: Props = $props()

	const removeItem = (cartItem: CartItem) => {
		const index: number = $cartItems.findIndex(item => item.product.id === cartItem.product.id)
		$cartItems.splice(index, 1)
		$cartItems = $cartItems // force reactive update
	}

	const total = $derived(
		$cartItems.reduce((sum, item) => sum + item.product.price * item.quantity, 0)
	)
</script>

<form novalidate>
	<div class="tw:w-full tw:grid tw:grid-cols-[60%_20%_20%] tw:gap-y-2">
		{#each $cartItems as cartItem}
			<div class="tw:break-words tw:min-w-0 tw:pt-2">
				{cartItem.product.name}
			</div>

			<div class="tw:text-center">
				<div class="tw:relative">
					<select
						bind:value={cartItem.quantity}
						class="tw:block tw:w-full tw:appearance-none tw:rounded-md tw:border tw:border-gray-200 tw:bg-white tw:px-4 tw:py-2 tw:pr-10 tw:text-base tw:text-gray-900 tw:shadow-sm tw:focus:!border-lilac tw:focus:ring-1 tw:focus:outline-0 tw:focus:ring-inset tw:focus:!ring-lilac">
						<option value={1} selected>1</option>
						<option value={2}>2</option>
						<option value={3}>3</option>
						<option value={4}>4</option>
						<option value={5}>5</option>
						<option value={6}>6</option>
						<option value={7}>7</option>
						<option value={8}>8</option>
						<option value={9}>9</option>
						<option value={10}>10</option>
					</select>
					<svg
						class="tw:absolute tw:right-3 tw:top-1/2 tw:h-4 tw:w-4 tw:-translate-y-1/2 tw:text-gray-500 tw:pointer-events-none"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 16 16"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M2 5l6 6 6-6"></path>
					</svg>
				</div>
			</div>

			<div class="tw:text-right tw:pt-2">
				${cartItem.quantity * cartItem.product.price}<br />
				<button
					class="tw:text-sm tw:text-plum tw:hover:text-orange-500"
					onclick={() => removeItem(cartItem)}>
					Remove
				</button>
			</div>
		{/each}
		{#if $cartItems.length > 0}
			<div class="tw:col-span-3 tw:text-end tw:font-bold">Total: ${total}</div>
		{:else}
			<span>You have nothing in your cart.</span>
		{/if}
	</div>

	{#if $cartItems.length > 0 && showCheckout}
		<div class="tw:flex tw:mt-4 tw:w-full">
			<a
				href="/checkout"
				onclick={onclose}
				title="Check out with credit card"
				class="tw:no-underline tw:mb-5 tw:text-center tw:w-full tw:bg-plum tw:text-white tw:border-0 tw:rounded-md tw:p-2 tw:text-xl tw:hover:bg-plum/90"
				>Check out with credit card</a>
		</div>
		<ApplePayButton onsuccess={onclose} />
	{/if}
</form>
